import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SecondaryLayoutButtonSliceState {
  showSubmitSurveyButton: boolean;
  showSubmitAssessmentButton: boolean;
}

const initialState: SecondaryLayoutButtonSliceState = {
  showSubmitSurveyButton: false,
  showSubmitAssessmentButton: false,
};

const secondaryLayoutButtonSlice = createSlice({
  name: 'secondaryLayoutButtonSlice',
  initialState,
  reducers: {
    setShowSurveySubmitButton(state, action: PayloadAction<boolean>) {
      state.showSubmitSurveyButton = action.payload;
    },
    setShowAssessmentSubmitButton(state, action: PayloadAction<boolean>) {
      state.showSubmitAssessmentButton = action.payload;
    },
  },
});

export const {
  setShowSurveySubmitButton,
  setShowAssessmentSubmitButton,
} = secondaryLayoutButtonSlice.actions;

export default secondaryLayoutButtonSlice.reducer;
